import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import Confetti from 'react-confetti';
import { Button } from '~/components/ui/button';
import { useCssVar } from '~/hooks/useCssVar';

import styles from './JoinButton.module.css';

export function JoinButton({ children, onClick }: PropsWithChildren<{ onClick?: () => void }>) {
    const ref = useRef<HTMLDivElement>(null);

    const yellow = useCssVar('--color-yellow')[0];
    const blue = useCssVar('--color-blue')[0];
    const green = useCssVar('--color-green')[0];

    const [dimensions, setDimensions] = useState({ x: 0, y: 0, w: 0, h: 0 });

    useEffect(() => {
        if (ref.current) {
            setDimensions({
                x: 0,
                y: 0,
                w: ref.current.getBoundingClientRect().width,
                h: ref.current.getBoundingClientRect().height,
            });
        }
    }, []);

    return (
        <div ref={ref} className={styles.container}>
            <Confetti
                className={styles.confetti}
                confettiSource={dimensions}
                width={dimensions.w}
                height={dimensions.h}
                numberOfPieces={30}
                tweenDuration={5000}
                initialVelocityY={0}
                initialVelocityX={0}
                gravity={0}
                colors={[yellow, blue, green] as string[]}
            />
            <Button className={styles.joinButton} onClick={onClick}>
                {children}
            </Button>
        </div>
    );
}
